import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import Organizations from 'containers/Organizations';
import { AddOrganization, EditOrganization } from 'containers/OrganizationForm';
import AddPractitioner from 'containers/AddPractitioner';
import Dictionary from 'containers/Dictionary';

const AdminRoutes = () => (
  <Switch>
    <Route exact path="/sites" component={Organizations} />
    <Route path="/sites/:id" render={props => <EditOrganization {...props} editMode />} />
    <Route path="/add-site" component={AddOrganization} />
    <Route path="/add-practitioner" component={AddPractitioner} />
    <Route path="/redcap" component={Dictionary} />
    <Redirect to="/sites" />
  </Switch>
);

export default AdminRoutes;
